import React, { useEffect, useState } from "react";
import { Card, Col, Input, Radio, Row, Tag, Spin, Empty, message } from "antd";
import styles from "./templates.module.css";
import { RiSearchLine } from "react-icons/ri";

export default function TemplateLibrary({ messaging, onSelect }) {
  const [category, setCategory] = useState("UTILITY");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [libraryTemplates, setLibraryTemplates] = useState([]);

  useEffect(() => {
    if (!messaging) return;
    setLoading(true);
    messaging
      .getTemplateLibrary({ category })
      .then((data) => {
        setLibraryTemplates(data.templates || []);
      })
      .catch((err) => {
        message.error(err.response?.data?.message || err.message || "Failed to load library");
      })
      .finally(() => setLoading(false));
  }, [messaging, category]);

  const filtered = libraryTemplates.filter(
    (t) =>
      t.name?.toLowerCase().includes(search.toLowerCase()) ||
      t.body?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className={styles.libraryView}>
      <div className={styles.libraryContainer}>
        <div className={styles.librarySidebar}>
          <div className={styles.librarySearch}>
            <Input
              prefix={<RiSearchLine />}
              placeholder="Search templates"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              allowClear
            />
          </div>
          <section>
            <h4>Category</h4>
            <Radio.Group
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className={styles.verticalRadio}
            >
              <Radio value="UTILITY">Utility</Radio>
              <Radio value="AUTHENTICATION">Authentication</Radio>
              <Radio value="MARKETING">Marketing</Radio>
            </Radio.Group>
          </section>
        </div>
        <div className={styles.libraryContent}>
          <div className={styles.libraryHeader}>
            <span>Showing {filtered.length} templates in {category.toLowerCase()}</span>
          </div>
          {loading ? (
            <div className={styles.libraryLoader}>
              <Spin size="large" tip="Fetching pre-approved templates..." />
            </div>
          ) : filtered.length > 0 ? (
            <Row gutter={[16, 16]}>
              {filtered.map((t) => (
                <Col span={12} key={t.id || t.name}>
                  <Card
                    hoverable
                    className={styles.libraryCard}
                    onClick={() => onSelect(t)}
                  >
                    <div className={styles.libraryCardHeader}>
                      <strong>{t.name.replace(/_/g, ' ')}</strong>
                      <Tag color="blue" style={{ marginLeft: 8 }}>{t.usecase || t.topic}</Tag>
                    </div>
                    <div className={styles.libraryCardBody}>
                      {(t.body || "").split('\n').map((line, i) => <div key={i}>{line}</div>)}
                    </div>
                    {t.buttons && t.buttons.length > 0 && (
                      <div className={styles.libraryCardButtons}>
                         {t.buttons.slice(0, 2).map((b, i) => (
                           <div key={i} className={styles.libraryCardBtnPreview}>
                             {b.text}
                           </div>
                         ))}
                      </div>
                    )}
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <Empty description="No templates found in the library" style={{ marginTop: 40 }} />
          )}
        </div>
      </div>
    </div>
  );
}
